import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
export function CtaBand() {
  return <section className="bg-navy" aria-labelledby="cta-heading" data-id="element-40" data-mp="ciu3uund0gji">
      <div className="mx-auto grid max-w-7xl items-end gap-10 px-6 py-20 lg:grid-cols-12 lg:px-8 lg:py-24" data-id="element-41" data-mp="hgm2e7iif0wo">
        <div className="lg:col-span-8" data-id="element-42" data-mp="mgi768z16wda">
          <span className="block h-px w-16 bg-gold" aria-hidden="true" data-id="element-43" data-mp="mhjlcmbcfyz8" />
          <h2 id="cta-heading" className="mt-8 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-44" data-mp="rejr0w4a6zpt">
            Ready to Elevate Your Executive Narrative?
          </h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-45" data-mp="107dbr92hyrb2">
            Whether you are targeting your next C-suite milestone, navigating a complex transition, or building a
            board dossier, let&rsquo;s position your value for maximum impact.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:col-span-4 lg:flex-col lg:items-stretch" data-id="element-46" data-mp="1f448faksdowz">
          <ButtonLink to="/contact" variant="light" data-id="element-47" data-mp="1z8emyibkgvi7">
            Schedule Executive Strategy Session
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="1u78saeyciy61" />
          </ButtonLink>
          <ButtonLink to="/services" variant="outlineLight" data-id="element-49" data-mp="1p8fh4t6j7j91">
            Explore Advisory Services
          </ButtonLink>
        </div>
      </div>
    </section>;
}